
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8e54"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8e54"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("fS26x", function(module, exports) {

$parcel$export(module.exports, "navbar", () => $b8dd880aea9d5f84$export$58733aaf927c3bbe);
$parcel$export(module.exports, "initNavbar", () => $b8dd880aea9d5f84$export$d75bb3493b7a8511);

const $b8dd880aea9d5f84$export$58733aaf927c3bbe = `
    <nav class="navbar">
        <div class="navbar-logo">
            <img class="navbar-logo__img" src="${new URL((parcelRequire("jjSvZ")))}" alt="logo">
            <p class="navbar-logo__text">Project Example</p>
            <button id="theme-toggle">\u{1F319}</button>
        </div>
        <ul class="navbar-menu">
            <li><a class="navbar-link" href="index.html">Home</a></li>
            <li><a class="navbar-link" href="about.html">About</a></li>
            <li><a class="navbar-link" href="services.html">Services</a></li>
            <li><a class="navbar-link" href="contact.html">Contact</a></li>
        </ul>
    </nav>
`;


function $b8dd880aea9d5f84$export$d75bb3493b7a8511() {
    const btn = document.getElementById("theme-toggle");
    const img = document.querySelector(".navbar-logo__img");
    function updateIcon() {
        btn.textContent = document.body.classList.contains("dark") ? "\u2600\uFE0F" : "\uD83C\uDF19";
        img.src = document.body.classList.contains("dark") ? new URL((parcelRequire("60MM6"))) : new URL((parcelRequire("jjSvZ")));
    }
    const savedTheme = localStorage.getItem("theme");
    if (savedTheme === "dark") document.body.classList.add("dark");
    updateIcon();
    btn.addEventListener("click", ()=>{
        document.body.classList.toggle("dark");
        if (document.body.classList.contains("dark")) localStorage.setItem("theme", "dark");
        else localStorage.setItem("theme", "light");
        updateIcon();
    });
}

});
parcelRegister("jjSvZ", function(module, exports) {
module.exports = import.meta.resolve("59zzA");

});

parcelRegister("60MM6", function(module, exports) {
module.exports = import.meta.resolve("2sHUj");

});



var $fS26x = parcelRequire("fS26x");
document.getElementById("navbar").innerHTML = (0, $fS26x.navbar);
(0, $fS26x.initNavbar)();
const $4387db1f46a3a981$var$carousel = document.querySelector(".services-preview__carousel");
const $4387db1f46a3a981$var$next = document.querySelector(".carousel__btn--next");
const $4387db1f46a3a981$var$prev = document.querySelector(".carousel__btn--prev");
function $4387db1f46a3a981$var$getScrollAmount() {
    const card = $4387db1f46a3a981$var$carousel.querySelector(".service-card");
    const track = $4387db1f46a3a981$var$carousel.querySelector(".carousel__track");
    const gap = parseInt(getComputedStyle(track).gap);
    return card.offsetWidth + gap;
}
$4387db1f46a3a981$var$next.addEventListener("click", ()=>{
    $4387db1f46a3a981$var$carousel.scrollBy({
        left: $4387db1f46a3a981$var$getScrollAmount(),
        behavior: "smooth"
    });
});
$4387db1f46a3a981$var$prev.addEventListener("click", ()=>{
    $4387db1f46a3a981$var$carousel.scrollBy({
        left: $4387db1f46a3a981$var$getScrollAmount(),
        behavior: "smooth"
    });
});


//# sourceMappingURL=path0.ae42bf02.js.map
